import Vue from 'vue';

class EventBusService extends Vue {
  public EVENT_SHOW_MODAL = 'EVENT_SHOW_MODAL'
  public EVENT_SHOW_TOAST_INFO = 'EVENT_SHOW_TOAST_INFO'
  public EVENT_SHOW_TOAST_SUCCESS = 'EVENT_SHOW_TOAST_SUCCESS'
  public EVENT_SHOW_TOAST_ERROR = 'EVENT_SHOW_TOAST_ERROR'
  public EVENT_SHOW_UPLOAD_MODAL = 'EVENT_SHOW_UPLOAD_MODAL'
  public EVENT_SHOW_TREE_MODAL = 'EVENT_SHOW_TREE_MODAL'
}
export const eventBusService = new EventBusService();
